import { RouteHandler } from 'wee-routes';
import $events from 'wee-events';
import $ from 'wee-dom';
import Tabbable from '../../scripts/tabbable';
import KeyHelper from '../../scripts/keyhelper';

export default new RouteHandler({
    init() {
        const $options = $(':addToCalendarOptions');

        const state = {
            active: false,
        };

        $events.on({
            ':addToCalendarButton': {
                click(e, el) {
                    $options.toggle();
                    state.active = ! state.active;

                    if (state.active) {
                        new Tabbable({
                            el: $options,
                            callback() {
                                $options.hide();
                            },
                        });
                    }

                    if (state.active) {
                        $events.on('body', 'click.addToCalendar', (e) => {
                            if (e.target !== el) {
                                $options.hide();
                                state.active = false;
                            }
                        });
                    } else {
                        $events.off(null, '.addToCalendar');
                    }

                    $options.ariaExpand(state.active);
                },
            },
            ':addToCalendarOptions': {
                keyup(e) {
                    if (KeyHelper.isEsc(e)) {
                        $options.hide();
                    }
                },
            },
        });
    },
});
